
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class PsAdvPromoHd2Grid extends Serenity.EntityGrid<PsAdvPromoHd2Row, any> {
        protected getColumnsKey() { return PsAdvPromoHd2Columns.columnsKey; }
        protected getDialogType() { return PsAdvPromoHd2Dialog; }
        protected getIdProperty() { return PsAdvPromoHd2Row.idProperty; }
        protected getInsertPermission() { return PsAdvPromoHd2Row.insertPermission; }
        protected getLocalTextPrefix() { return PsAdvPromoHd2Row.localTextPrefix; }
        protected getService() { return PsAdvPromoHd2Service.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();

            // remove first button (Add button)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );
            return buttons;

        }
    }
}